import React, { Fragment } from 'react';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
import Search from '@material-ui/icons/Search';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import CustomInput from '../../components/UI/CustomInput/CustomInput';
import Button from '../../components/UI/CustomButtons/Button';

import filterStyle from '../../assets/jss/coscef/views/filterStyle';

const useStyles = makeStyles(filterStyle);

const Filter = (props) => {
  const classes = useStyles();

  return (
    <Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <div className={classes.moveTo}>
            <CustomInput
              inputRootCustomClasses={classes.inputRootCustomClasses}
              formControlProps={{
                className: classes.formControl,
              }}
              inputProps={{
                placeholder: 'Buscar ' + props.nombreComponente + '...',
                inputProps: {
                  name: 'search',
                  className: classes.searchInput,
                },
                onChange: (event) => {
                  props.searchChange(event);
                },
                autoComplete: 'off',
              }}
            />
            <Button color='white' justIcon round onClick={props.runSearch}>
              <Search className={classes.searchIcon} />
            </Button>
          </div>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
};

export default Filter;
